import {AdjustmentNoteCategoryEnum} from '@gtpl/shared-models/common-models'

export class AdjustmentNoteReq{
    category:AdjustmentNoteCategoryEnum
    adjustmnetNoteItemsInfo: AdjustmentNoteItemsInfo[]
    

    constructor(category:AdjustmentNoteCategoryEnum,adjustmnetNoteItemsInfo:AdjustmentNoteItemsInfo[]){
        this.category = category
        this.adjustmnetNoteItemsInfo = adjustmnetNoteItemsInfo
    }
}

export class AdjustmentNoteItemsInfo{
    vendorId:number
    invoiceNumber:string
    poId:number
    itemId:number
    price:number
    quantity:number
    taxAmount:number
    totalAmount:number
    grnItemId:number
    grnId:number
    vendorCode:string
    taxPercent : number

    constructor(vendorId:number,invoiceNumber:string,poId:number,itemId:number,price:number,quantity:number,taxAmount:number,totalAmount:number,grnItemId:number,grnId:number,vendorCode:string,taxPercent : number){
        this.vendorId = vendorId
        this.invoiceNumber = invoiceNumber
        this.poId = poId
        this.itemId = itemId
        this.price = price
        this.quantity = quantity
        this.taxAmount = taxAmount
        this.totalAmount = totalAmount
        this.grnItemId = grnItemId
        this.grnId = grnId
        this.vendorCode = vendorCode
        this.taxPercent = taxPercent
    }
}